<template>
<div class="container">
    <div class="row instagram-feed" id="instaFeed">
        <div class="col-6">
            <a target="_blank" href="https://www.theknot.com/marketplace/redirect-1046401">
                <div style="display: inline-block; font-size: 10px; text-align: center;">
                    <img class="wedd-images" src="https://images.prismic.io/bonjourbrigadeiro/97063de5-bf39-4b2d-9fcf-c7017e652729_BOW_DigitalBadge_2020_500x500.png?auto=compress,format" alt="The Knot Best of Weddings - 2020 Pick" border="0" style="margin:0 auto; display:block;">
                </div>
            </a>
        </div>
         <div class="col-6">
            <a target="_blank" href="https://www.bridesofaustin.com/vendors/bonjour-brigadeiro/">
                <div style="display: inline-block; font-size: 10px; text-align: center;">
                    <img class="wedd-images" src="https://images.prismic.io/bonjourbrigadeiro/bd9d426a-0f7d-455f-919a-27fa090c4780_boa_preferredvendor_2019.png?auto=compress,format"  alt="The Knot Best of Weddings - 2020 Pick" border="0" style="margin:0 auto; display:block;">
                </div>
            </a>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: 'Weddinglinks'
    }
</script>
<style lang="scss">
.wedd-images {
    width: 300px;
    height: 300px;
    @media (max-width: 500px){
        width: 150px;
        height: 150px;
    }
}
.instagram-feed {
    margin-left: 0px;
    margin-right: 0px;
    padding-top: 50px;
    text-align: center;
 
    h2 {
        font-family: "lust-script",sans-serif;
        font-size: 3em;
        color: #300B02;
    }
    .insta-title {
        padding-left: 25px;
        padding-bottom: 25px;
    }

}

</style>